export default {
    data() {
        return {
            reasons: [
                'Not as described',
                'Wrong pressing',
                'Lost',
                'On different order',
                'Accidental add',
                'Did not want',
                'Too expensive',
                'Found another',
                'Return',
            ]
        }
    }
}